import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import RegionalRepository from "./routes/RegionUnitRepo";
export default store => ({
  path: "unit-publishing",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "unit-publishing" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [RegionalRepository(store)],
});
